import { useEffect } from 'react'
import Navbar from './components/Navbar'
import ChatInterface from './components/ChatInterface'
import Footer from './components/Footer'
import { setUserCookie, getUserId } from './utils/cookies'
import './App.css'

function App() {
  useEffect(() => {
    // Set anonymous user cookie on first visit
    const existingUserId = getUserId()
    if (!existingUserId) {
      setUserCookie()
    }
  }, [])

  return (
    <div className="app">
      {/* Decorative background elements */}
      <div className="bg-gradient" aria-hidden="true" />
      <div className="bg-grid" aria-hidden="true" />
      <div className="bg-glow bg-glow-1" aria-hidden="true" />
      <div className="bg-glow bg-glow-2" aria-hidden="true" />

      <Navbar />

      <main className="main">
        <ChatInterface />
      </main>

      <Footer />
    </div>
  )
}

export default App
